import { notificationStore } from '@pascal/pascal-core/shared/core/store';
import {
  isMobile,
  useTranslation,
  BetResponseCode,
  TranslationKeys,
  plus,
  multiply,
} from '@pascal/pascal-core';
import { AdditionalInputValueChangingButtons } from '@pascal/pascal-core/shared/core/enums/additionalInputValueChangingButtons';

import { Winning } from '../../common';
import { KeyCodes, TKeys } from '../../../enums';
import { createGuid } from '../../../helpers/createGuid';
import { betAmountValidator } from '../../../helpers/supporters';
import { gameLiveConnection } from '../../../services/GameConnection';
import { doBetStore } from '../../../store/doBetStore';

const BetSection = ({
  isDemo,
  limits,
  roundId,
  betAmount,
  reBetData,
  onBetClick,
  gameTypeId,
  replayData,
  onInputClick,
  setBetAmount,
  activeButton,
  activeFreeBet,
  selectedMarket,
  totalBetsAmount,
  isLoadingBetButton,
  isLoadingReBetButton,
  partnerWageringOdd,
  handleChangeAmount,
  decidedCallBackCall,
  setIsValidatedAmount,
}) => {
  const t = useTranslation();
  const { minBet = 0 } = limits;
  const { odd } = selectedMarket;

  const isBetDisabled = activeButton || isLoadingBetButton || isLoadingReBetButton;

  const handleReBetClickAction = () => {
    const reBetModel = {
      roundId,
      gameTypeId,
      amount: reBetData.reduce((acc, curr) => acc + curr.amount, 0),
      freeBetId: activeFreeBet?.id && !isDemo ? activeFreeBet?.id : null,
      betData: reBetData.map((el) => {
        return {
          isReBet: true,
          amount: el.amount,
          marketType: el.marketType,
          id: createGuid(),
          freeBetId: activeFreeBet?.id && !isDemo ? activeFreeBet?.id : null,
        };
      }),
    };

    doBetStore.setIsLoadingReBetButton(true);
    gameLiveConnection.doBet(reBetModel);
  };

  const handleKeyPress = (e) => {
    const keyCode = e.keyCode || e.which;
    if (keyCode === KeyCodes.Enter) {
      e.preventDefault();
    }
  };

  const handleBetAction = () => {
    if (isBetDisabled) return;
    if (selectedMarket?.odd) {
      if (isDemo && plus(Number(betAmount), Number(totalBetsAmount)) > Number(limits.maxBet)) {
        notificationStore.setNotificationType({ responseCode: BetResponseCode.InValidMaxBet });
      } else {
        decidedCallBackCall(() => onBetClick());
      }
    } else {
      notificationStore.setNotificationType({ responseCode: BetResponseCode.InValidMarket });
    }
  };

  const handleKeyUp = (e) => {
    const keyCode = e.keyCode || e.which;
    if (keyCode === KeyCodes.Enter) {
      handleBetAction();
    }
  };

  const handleRightButtonClass = (isReBet) => {
    if (
      !isBetDisabled &&
      ((isReBet && !isLoadingReBetButton) || !isLoadingBetButton) &&
      (isDemo ||
        (!activeFreeBet.id && !partnerWageringOdd) ||
        (!isDemo &&
          ((activeFreeBet.id && activeFreeBet.minOdd <= odd) ||
            (partnerWageringOdd && partnerWageringOdd <= odd) ||
            odd === undefined)))
    ) {
      return 'pulse-anim';
    }
    return '';
  };

  const handleFreeBetDisableState = () => {
    if (
      (activeFreeBet.id && activeFreeBet.minOdd > odd) ||
      (partnerWageringOdd && partnerWageringOdd > odd)
    ) {
      return 'free-bet-disabled disabled';
    }
    return '';
  };

  const handleFreeBetState = () => {
    if (!isDemo && (activeFreeBet.id || partnerWageringOdd)) {
      return `free-bet ${handleFreeBetDisableState()}`;
    }
    return '';
  };
  const handleGameButtonClass = () => {
    if (isBetDisabled) {
      return `disabled ${handleFreeBetState()}`;
    }
    return handleFreeBetState();
  };

  return (
    <div className='m-content-bottom-inside'>
      <div className='g-bot-area-bet'>
        <div className='g-bot-area-bet-left'>
          <Winning />
          <div className='g-bot-area-btn-wr'>
            <div className='g-bot-area-inp-ins'>
              <div
                onClick={() => handleChangeAmount(AdditionalInputValueChangingButtons.divide)}
                className={`g-bot-area-inp-left ${activeFreeBet.id && !isDemo ? 'passive' : ''}`}
              >
                <span className='g-bot-ar-c-sp'>1/2</span>
              </div>
              <div className='g-bot-area-inp-center'>
                <span
                  className={`inp-game-block minus ${activeFreeBet.id && !isDemo ? 'passive' : ''}`}
                  onClick={() =>
                    !activeFreeBet.id &&
                    handleChangeAmount(AdditionalInputValueChangingButtons.minus)
                  }
                >
                  <i className='ui-lib-minus' />
                </span>
                <input
                  type='text'
                  maxLength={9}
                  className='inp-game-c'
                  disabled={activeFreeBet.id && !isDemo}
                  onClick={(e) => {
                    if (isMobile()) {
                      e.stopPropagation();
                      onInputClick(e);
                    }
                  }}
                  readOnly={isMobile()}
                  autoComplete='off'
                  inputMode={isMobile() ? 'none' : 'text'}
                  onChange={(e) => {
                    if (
                      /^([0]{1}|([1-9]{1}\d*))(?:\.\d{0,2})?$/.test(e.target.value) ||
                      e.target.value === ''
                    ) {
                      setBetAmount(e.target.value.replace(',', '.'));
                    }
                  }}
                  onBlur={() => {
                    const { validatedBetAmount, errorMessageCode } = betAmountValidator(
                      betAmount,
                      limits
                    );
                    if (errorMessageCode) {
                      notificationStore.setNotificationType({ responseCode: errorMessageCode });
                      setIsValidatedAmount(true);
                      setTimeout(() => setIsValidatedAmount(false), 200);
                    }
                    // iframeService.sendStakeUpdate(validatedBetAmount);
                    setBetAmount(validatedBetAmount);
                  }}
                  value={betAmount || ''}
                  onPaste={(e) => e.preventDefault()}
                  {...(isMobile() && !activeFreeBet.id ? { onClick: (e) => onInputClick(e) } : {})}
                />
                <span
                  className={`inp-game-block plus ${activeFreeBet.id && !isDemo ? 'passive' : ''}`}
                  onClick={() =>
                    !activeFreeBet.id &&
                    handleChangeAmount(AdditionalInputValueChangingButtons.plus)
                  }
                >
                  <i className='ui-lib-plus' />
                </span>
              </div>
              <div
                onClick={() => handleChangeAmount(AdditionalInputValueChangingButtons.multiply, 2)}
                className={`g-bot-area-inp-left ${activeFreeBet.id && !isDemo ? 'passive' : ''}`}
              >
                <span className='g-bot-ar-c-sp'>x2</span>
              </div>
            </div>
            <div className='g-bot-ar-btn-ins'>
              <div
                onClick={() => handleChangeAmount(AdditionalInputValueChangingButtons.min)}
                className={`g-bot-ar-btn-ins-item ${
                  betAmount === limits.minBet || (activeFreeBet.id && !isDemo) ? 'passive' : ''
                }`}
              >
                <span className='g-bot-ar-c-sp'>{t('MIN')}</span>
              </div>
              <div
                onClick={() => {
                  const installableAmount = multiply(minBet, 3);
                  // if (+betAmount !== +installableAmount) {
                  //   iframeService.sendStakeUpdate(installableAmount);
                  // }
                  setBetAmount(installableAmount);
                }}
                className={`g-bot-ar-btn-ins-item ${activeFreeBet.id && !isDemo ? 'passive' : ''}`}
              >
                <span className='g-bot-ar-c-sp'>
                  {multiply(replayData ? replayData?.limits.minBet : minBet, 3)}
                </span>
              </div>
              <div
                onClick={() => setBetAmount(multiply(minBet, 5))}
                className={`g-bot-ar-btn-ins-item ${activeFreeBet.id && !isDemo ? 'passive' : ''}`}
              >
                <span className='g-bot-ar-c-sp'>
                  {multiply(replayData ? replayData?.limits.minBet : minBet, 5)}
                </span>
              </div>
              <div
                onClick={() => {
                  const installableAmount = multiply(minBet, 7);
                  // if (+installableAmount !== +betAmount) {
                  //   iframeService.sendStakeUpdate(installableAmount);
                  // }
                  setBetAmount(installableAmount);
                }}
                className={`g-bot-ar-btn-ins-item ${activeFreeBet.id && !isDemo ? 'passive' : ''}`}
              >
                <span className='g-bot-ar-c-sp'>
                  {multiply(replayData ? replayData?.limits.minBet : minBet, 7)}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className='g-bot-area-bet-right'>
          <div className='bet-right-btn'>
            <div
              className={`btn-game-holder bet ${handleGameButtonClass()} ${handleRightButtonClass()}`}
            >
              <button
                onClick={handleBetAction}
                onKeyUp={handleKeyUp}
                onKeyPress={handleKeyPress}
                className='btn-game'
              >
                <span className='btn-game-txt'>
                  {activeFreeBet.id && !isDemo
                    ? `${t(TranslationKeys.FreeBet)} ${activeFreeBet.remainingCount}`
                    : t(TranslationKeys.Bet)}
                </span>
                <span className='btn-game-small-txt'>
                  {(activeFreeBet.id && !isDemo && !activeFreeBet.isMinOddNull) ||
                  (partnerWageringOdd && !isDemo)
                    ? `${t(TranslationKeys.MinOdd)} x${activeFreeBet.minOdd || partnerWageringOdd}`
                    : ''}
                </span>
              </button>
              {isLoadingBetButton && (
                <div className={`circle-loader ${isMobile() ? 'mobile' : ''}`} />
              )}
            </div>
            {reBetData.length && reBetData[0].roundId !== roundId ? (
              <div
                className={`btn-game-holder rebet ${handleGameButtonClass()} ${handleRightButtonClass(
                  true
                )}`}
              >
                {isLoadingReBetButton && <div className='circle-loader' />}
                <button className='btn-game' onClick={() => handleReBetClickAction()}>
                  <i className='ui-lib-rebet' />
                  <span className='btn-game-txt'>{t(TKeys.ReBet)}</span>
                </button>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BetSection;
